import { formatISO } from 'date-fns';
import { useIntl } from 'react-intl';

import { useAppConfigContext } from '~/contexts/AppConfig';
import { DateInput } from '~/eds/src/components/DateInput/DateInput';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { parseDate } from '~/eds/src/utils/parseDate';
import { DATE_FORMAT_TYPE_TO_DATE_FORMAT } from '~/enums/DateFormatType';
import { Nullable } from '~/types/Nullable';

import { DateCustomSettings } from '../types/fields';
import { WorkflowQuestionFormField } from './types';

export const DateWorkflowQuestion = ({
  question,
  onChange,
  minDate,
  ...rest
}: WorkflowQuestionFormField<Nullable<string>>) => {
  const { isPanelEnlarged } = useAppConfigContext();
  const intl = useIntl();
  const {
    field: { value, customSettings },
  } = question;
  const { format } = customSettings as DateCustomSettings;

  const handleDateChange = (val: Date | null) => {
    const isoDate = val ? formatISO(val, { representation: 'date' }) : '';
    onChange(isoDate, 'value');
  };

  return (
    <FormField
      {...rest}
      input={DateInput}
      value={value.value ? parseDate(value.value) : undefined}
      onChange={handleDateChange}
      inputProps={{
        format: format ? DATE_FORMAT_TYPE_TO_DATE_FORMAT[format] : undefined,
        placeholder: intl.formatMessage({
          id: 'DateWorkflowQuestion.datePlaceholder',
          defaultMessage: 'Select a date',
          description: 'Placeholder for date input in the intake form',
        }),
        width: isPanelEnlarged ? 'input.m.width' : '100%',
        min: minDate,
      }}
    />
  );
};
